import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { merge, Observable, of as observableOf, Subject, Subscription } from 'rxjs';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
// import { saveAs } from 'file-saver/FileSaver';
import { MatPaginator, MatTableDataSource, MatSort, MatSnackBar, MatDialog } from '@angular/material';
import { UserService } from '../../../../services/user.service';
import { ManagePukalService } from '../../../../services/manage-pukal.service';
import { SelectionModel } from '@angular/cdk/collections';
import { ManagePukalLoadingDialog } from '../../dialog.loading';
import { ManagePukalDownloadFileDialog } from '../../dialog.downloadFile';
import { EditAccountPukalSarawakGovernmentDialog } from '../../ptj-list/swk-government/dialog.editaccount';
import { AddNewAccountPukalSarawakGovernmentDialog } from '../../ptj-list/swk-government/dialog.addnewaccount';
import { AccountOffice, AccountStatus, RecordStatus, PukalPagedList, SearchSarawakPukal } from '../../../../models/pukal-reports.model';
import { PukalAccountStatus } from '../../../../shared/enum';

@Component({
  selector: 'app-swk-government',
  templateUrl: './swk-government.component.html',
  styleUrls: ['./swk-government.component.css']
})
export class PtjListSwkGovernmentComponent implements OnInit, OnDestroy {
  allSub: Subscription[] = [];
  errorMessage: string = '';
  userName: string = '';
  screenCode: string = '';
  agentCodes = [];
  accStatus = [];
  rcdStatus = [];
  AutoNos = [];
  kodPtj: string = '';
  accNo: string = '';
  selectedAgentCode: string = '';
  selectedAccStsCode: string = '0';
  selectedRcdStsCode: string = '0';
  warrant_auth_code: string = 'SW';
  isLoadingResults: boolean = true;
  resultsLength: number = 0;
  totalCount: number = 0;
  searchPukal: SearchSarawakPukal;

  selection: SelectionModel<PukalPagedList> = new SelectionModel<PukalPagedList>(true, []);
  data: PukalPagedList[];
  dataSource: MatTableDataSource<PukalPagedList>;
  displayedColumns: string[] = ['Select', 'Edit', 'AgencyCode', 'Agency', 'PukalNo', 'PtjCode', 'Email', 'Description', 'FileStatus', 'AccStatus'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  recordChange$: Subject<{}> = new Subject();
  accOffices$: Observable<AccountOffice[]>;
  accStatus$: Observable<AccountStatus[]>;
  recordStatus$: Observable<RecordStatus[]>;

  constructor(private userService: UserService,
    private managePukalService: ManagePukalService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog) {
    let user = this.userService.getUser();
    this.userName = user.username;
    this.screenCode = user.screenCode;

    this.accStatus$ = this.managePukalService.getAccountStatus();
    this.recordStatus$ = this.managePukalService.getRecordStatus();

    this.managePukalService.getPtjSearchFieldByWarrantAuthCode(this.warrant_auth_code)
      .subscribe(
        (value) => {
          this.agentCodes = value;
          this.selectedAgentCode = value[0].Airline_Agency_Code;
        },
        (error) => {
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
        });
  }

  ngOnInit() {
    this.searchPukal = {
      agentCode: this.selectedAgentCode,
      accountStatus: this.selectedAccStsCode,
      fileStatus: this.selectedRcdStsCode,
      ptjCode: this.kodPtj,
      accNo: this.accNo,
      page: null
    };

    merge(this.recordChange$)
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;

          return this.managePukalService.getFilteredSarawakPukal(this.searchPukal);
        }),
        map(data => {
          this.isLoadingResults = false;
          this.resultsLength = data.countPukalList;

          this.dataSource = new MatTableDataSource<PukalPagedList>(data.pukalPagedList)
          this.dataSource.paginator = this.paginator;

          this.AutoNos.push(this.dataSource.data.map(a => a.Auto_No));

          return data.pukalPagedList;
        }),
        catchError((error) => {
          this.isLoadingResults = false;
          this.errorMessage = <any>error;
          this.openSnackBar(this.errorMessage, '');
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }

  exportList() {
    let cfm = confirm("Are you sure you want to export the List?");

    if (cfm) {
      let pukal = {
        url: "SwkExportPukalList",
        agentCode: this.selectedAgentCode,
        accountStatus: this.selectedAccStsCode,
        fileStatus: this.selectedRcdStsCode,
        accNo: this.accNo,
        ptjCode: this.kodPtj,
        Auto_Nos: this.AutoNos
      }

      let dialogRef = this.dialog.open(ManagePukalDownloadFileDialog, {
        width: '250px',
        disableClose: true,
        data: { downloadParameter: pukal }
      });

      dialogRef.afterClosed().subscribe(result => {
        switch (result.status) {
          case -1:
            this.openSnackBar(result.message, '');
            break;
          case 1:
            this.openSnackBar(result.message, '');
            break;
        }
      });
    }
  }

  searchPukalList() {
    this.selection.clear();
    this.dataSource = new MatTableDataSource<PukalPagedList>();
    this.paginator.pageIndex = 0;

    this.searchPukal = {
      agentCode: this.selectedAgentCode,
      accountStatus: this.selectedAccStsCode,
      fileStatus: this.selectedRcdStsCode,
      ptjCode: this.kodPtj,
      accNo: this.accNo,
      page: null
    };

    this.recordChange$.next();
  }

  activeSelected() {
    var cfm = confirm("Are you sure you want to activate those selected Pukal account(s)?");

    if (cfm) {
      if (this.selection.selected.length > 0) {
        //loading dialog
        this.openLoadingDialog();

        let updatePukalModel = {
          Pukals: this.selection.selected,
          AccountStatus: PukalAccountStatus.ACTIVATE
        }

        let sub = this.managePukalService.updateSWKPukalAccountStatus(updatePukalModel)
          .subscribe(
            (data) => {
              this.dialog.closeAll();
              this.openSnackBar('Selected Pukal account(s) Activated.', '');
              this.searchPukalList();
              // this.selectedPukalList = []; // refresh selected list
            },
            error => {
              this.selection.clear();
              this.dialog.closeAll();
              this.errorMessage = <any>error;
              this.openSnackBar(this.errorMessage, '');
            });

        // Adds into array for each subscribe
        this.allSub.push(sub);
      } else {
        this.openSnackBar('No Pukal account is selected. Please make sure at least one Pukal account is selected.', '');
      }
    }
  }

  deactiveSelected() {
    var cfm = confirm("Are you sure you want to deactivate those selected Pukal account(s)?");

    if (cfm) {
      if (this.selection.selected.length > 0) {
        //loading dialog
        this.openLoadingDialog();

        let updatePukalModel = {
          Pukals: this.selection.selected,
          AccountStatus: PukalAccountStatus.DEACTIVATE
        }

        let sub = this.managePukalService.updateSWKPukalAccountStatus(updatePukalModel)
          .subscribe(
            (data) => {
              this.dialog.closeAll();
              this.openSnackBar('Selected Pukal account(s) Deactivated.', '');
              this.searchPukalList();
              // this.selectedPukalList = []; // refresh selected list
            },
            error => {
              this.selection.clear();
              this.dialog.closeAll();
              this.errorMessage = <any>error;
              this.openSnackBar(this.errorMessage, '');
            });

        // Adds into array for each subscribe
        this.allSub.push(sub);
      } else {
        this.openSnackBar('No Pukal account is selected. Please make sure at least one Pukal account is selected.', '');
      }
    }
  }

  terminateSelected() {
    var cfm = confirm("Are you sure you want to terminate those selected Pukal account(s)?");

    if (cfm) {
      if (this.selection.selected.length > 0) {
        //loading dialog
        this.openLoadingDialog();

        let updatePukalModel = {
          Pukals: this.selection.selected,
          AccountStatus: PukalAccountStatus.TERMINATE
        }

        let sub = this.managePukalService.updateSWKPukalAccountStatus(updatePukalModel)
          .subscribe(
            (data) => {
              this.dialog.closeAll();
              this.openSnackBar('Selected Pukal account(s) Terminated.', '');
              this.searchPukalList();
              // this.selectedPukalList = []; // refresh selected list
            },
            error => {
              this.selection.clear();
              this.dialog.closeAll();
              this.errorMessage = <any>error;
              this.openSnackBar(this.errorMessage, '');
            });

        // Adds into array for each subscribe
        this.allSub.push(sub);
      } else {
        this.openSnackBar('No Pukal account is selected. Please make sure at least one Pukal account is selected.', '');
      }
    }
  }

  openAddNewAccDialog() {
    let dialogRef = this.dialog.open(AddNewAccountPukalSarawakGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: {}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Add new successful') {
        this.searchPukalList();
        this.openSnackBar('Add new account successful.', '');
      }
    });
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource == null ? 0 : this.dataSource.data.length;

    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.data.forEach(row => this.selection.select(row));
  }

  openEditPukalListDialog(accData: any): void {
    let dialogRef = this.dialog.open(EditAccountPukalSarawakGovernmentDialog, {
      width: '60%',
      disableClose: true,
      data: { selectedAcc: accData, screenCode: this.screenCode }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Edit successful') {
        this.searchPukalList();
        this.openSnackBar('Edit successful.', '');
      }
    });
  }

  openLoadingDialog(): void {
    let dialogRef = this.dialog.open(ManagePukalLoadingDialog, {
      disableClose: true,
      width: '250px'
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed');
    });
  }

  ngOnDestroy() {
    for (let sub of this.allSub) {
      sub.unsubscribe();
    }
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }
}
